import * as React from 'react';

import { useRoutes } from 'src/explore/hooks/useRoutes';

import styles from './index.module.sass';

export const Agreement: React.FC = () => {
  const routes = useRoutes();

  return (
    <div className="mt-4 fs-4">
      <div>By signing up, you agree to our</div>
      <ul className="mt-2">
        <li className={`${styles.item} d-inline`}>
          {window.isNativeMobileApp ? (
            <a href={routes.terms()} target="_blank" rel="noreferrer">
              Terms of Service
            </a>
          ) : (
            <a href={routes.terms()}>Terms of Service</a>
          )}
        </li>
        <li className={`${styles.item} d-inline`}>
          <a target="_blank" href={routes.help.returnPolicy()} rel="noreferrer">
            Returns/Refunds Policy
          </a>
        </li>
        <li className={`${styles.item} d-inline`}>
          {window.isNativeMobileApp ? (
            <a href={routes.privacy()} target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
          ) : (
            <a href={routes.privacy()}>Privacy Policy</a>
          )}
        </li>
      </ul>
    </div>
  );
};
